<template>
  <div id="access">
    <ipub-row>
      <ipub-col class="bg-left"
                :span='4'></ipub-col>
      <ipub-col class="bg-right"
                :span='8'></ipub-col>
    </ipub-row>
    <div class="ipub-common-content">
      <ipub-row :gutter='60'>
        <ipub-col :span='5.5'>
          <div class="access-content">
            <div class="ipub-shadow">
              <div class="ipub-p1 mar-b-12"
                   style="font-size:16px">Welcome to</div>
              <a :href="publisherInfo.website"
                 target="_blank">
                <img class="access-content__logo mar-b-40"
                     :src="`${domain}/${publisherInfo.logo}`"
                     alt="">
              </a>
              <router-view></router-view>
            </div>
          </div>
        </ipub-col>
        <ipub-col :span='6.5'>
          <div class="journal-content">
            <div class="journal-content-notice mar-b-20">
              <div class="ipub-p1 mar-b-4"
                   style="display:flex;font-size:20px">
                <font class="warning-color"
                      style="font-size: 30px">
                  <ipub-icon type="iconDetails" />
                </font>
                <font class="mar-l-10">Having problems when login or register?</font>
              </div>
              <div class="mar-l-40 ipubw-p2">
                Please contact us by <a class="link-color"
                   href="mailto:it@imrpress.com">it@imrpress.com</a> and attach the screenshot with the error message.
              </div>
            </div>
            <div class="ipub-p2 mar-b-40"
                 style="font-size:16px">
              This login page provides access to the following journals published by {{publisherInfo.fullName}} for submitting or reviewing manuscripts.
            </div>
            <div class="journal-content__list">
              <div v-for="(item, index) in journalList"
                   class="journal-content__list__item"
                   :key="'access-content-journal'+index">
                <img :src="`${domain}/${item.cover}`"
                     alt="">
              </div>
            </div>
          </div>
        </ipub-col>
      </ipub-row>
    </div>
    <div class="access-footer ipub-p3">
      {{publisherInfo.copyright || '©2022 IMR Press.'}}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
